export enum QSetReviewSubtaskReviewResult {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  ApprovedPartially = 'APPROVED_PARTIALLY',
}
